import { Component, OnInit } from '@angular/core';
import {
  AngularFirestore,
  QueryDocumentSnapshot,
  QuerySnapshot,
} from '@angular/fire/firestore';
import { Collection } from 'src/app/interfaces/collection';
import { CollectionsService } from 'src/app/services/collections.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss'],
})
export class CollectionsComponent implements OnInit {
  editCollectionModalVisible = false;
  fetching = false;
  lastDocSnapshot?: QueryDocumentSnapshot<Collection>;

  constructor(
    public userService: UserService,
    public collectionsService: CollectionsService
  ) {}

  ngOnInit() {}
}
